import React from 'react';
import BILFooterButtonsPSD2 from '../Button/BILFooterButtonsPSD2';
import BILFooterButtonPSD2 from '../Button/BILFooterButtonPSD2';

import './index.less';

const BILFooterPSD2 = (props) => {
    return (
        <Footer>
            <div className="BIL-footer-PSD2-inputs-container">
                {!props.onlyOneButton ?
                    <BILFooterButtonsPSD2
                        {...props}
                    />
                    :
                    <BILFooterButtonPSD2
                        {...props}
                    />}
            </div>
        </Footer>
    )
}

const Footer = ({ children }) => {
    return (
        <div>
            <div className='BIL-footer-PSD2-phantom' />
            <div className='BIL-footer-PSD2'> {children} </div>
        </div>
    )
}

export default (BILFooterPSD2)